import { FieldSet, Label, LabeledControl, Legend, Radio, Text } from '@zillow/constellation-10';
import { EXTERNAL_WIZARD_OPTIONS, WIZARD_SCREEN_TYPES } from '../../../constants/stringConstants';

export default function WhatDoYouWantToDoWithYourLeaseNoUpdate({ onRadioSelect }: { onRadioSelect }) {
  return (
    <FieldSet required legend={<Legend>What do you want to do with your lease?</Legend>}>
      <LabeledControl
        label={
          <Label>
            Replace it
            <br />
            <Text css={{ color: 'text.subtle' }}>
              Replace the current lease with a new one — the best option for updating multiple terms.
            </Text>
          </Label>
        }
        control={
          <Radio
            name="what-do-you-want-to-do-no-update"
            value={EXTERNAL_WIZARD_OPTIONS.CREATE_LEASE}
            onChange={onRadioSelect}
          />
        }
      />
      <LabeledControl
        label={
          <Label>
            Leave it as is
            <br />
            <Text css={{ color: 'text.subtle' }}>
              If your lease automatically converts to month-to-month when the fixed-term expires and you don’t need to
              make any changes.
            </Text>
          </Label>
        }
        control={
          <Radio
            name="what-do-you-want-to-do-no-update"
            value={WIZARD_SCREEN_TYPES.YOUR_UPCOMING_LEASE_TERM_WILL_BE_MONTH_TO_MONTH}
            onChange={onRadioSelect}
          />
        }
      />
    </FieldSet>
  );
}
